// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './vuex/store'
import router from './router'
import vuelidate from 'vuelidate'
import filters from './filters'
import VueLocalStorage from 'vue-localstorage'
import VueCookies from 'vue-cookies'
import VueCroppie from 'vue-croppie';

Vue.use(VueCroppie)
Vue.use(VueCookies)
Vue.config.productionTip = true
Vue.use(VueLocalStorage)
Vue.use(vuelidate)
Vue.filter('round', function (value, precision) {
    return filters.round(value, precision)
})
// Vue.filter('roundOnePlace', function (value) {
//     value = Number(value)
//     return Math.round10(value, -1);
// })

const stepsUrl = {
    1: 'jmenomazlicka',
    2: 'rasa',
    // 3: 'fotografie',
    3: 'narozeniny',
    4: 'pohlavi',
    5: 'hmotnostkondice',
    6: 'pohyb',
    7: 'alergie',
    8: 'suroviny',
    9: 'hotovekrmivo'
}

function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
}

router.beforeEach((to, from, next) => {

    if (from.name === to.name) {
        return next();
    }

    if (from.name == null && window.konfigurator && window.konfigurator.step) {
        const url = stepsUrl[window.konfigurator.step];

        if (to.name != url) {
            return next({name: url});
        } else {
            return next();
        }

    }

    if (to.name != stepsUrl[1] && from.name == null && !Vue.$cookies.get('lastVisitedStep')) {
        return next({name: stepsUrl[1]})
    }

    let stepId = Vue.$cookies.get('lastVisitedStep')

    if(from.name != null && stepId) {

        var toUrlIndex = getKeyByValue(stepsUrl, to.name);

        var currStep = Number(stepId) + 1;

        if(toUrlIndex && Number(toUrlIndex) > currStep) {
            return next({name: stepsUrl[stepId]});
        } else {
            return next();
        }
    }

    if(from.name == null && stepId && to.name != stepsUrl[stepId]) {
        return next({name: stepsUrl[stepId]});
    }

    return next();
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    localStorage: {
        lastVisitedStep: {
            type: Number,
            default: 0
        }
    },
    vuelidate,
    template: '<App/>',
    components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js